<!-- 概览 -->
<template>
    <div class='student_contaniner'>
        <!--左边-->
        <div class="box_f1 box box_v" style="margin-right:10px">
            <card1 class="box box_f1"></card1>
            <card2 class="box" ></card2>
            <card3 class="box"></card3>
        </div>
        <!--中间-->
        <div class="box_f2 box box_v" style="margin:0 10px">
            <card4 class="box" style="margin-bottom:10px;"></card4>
            <cardMap class="box box_f1"></cardMap>
        </div>
        <!--右边-->
        <div class="box_f1 box box_v" style="margin-left:10px">
            <card5 class="box box_f1" style="margin-bottom:10px"></card5>
            <card6 class="box box_f2" style="margin-bottom:10px"></card6>
            <card7 class="box box_f2"></card7>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import card1 from "./card1"
import card2 from "./card2"
import card3 from "./card3"
import cardMap from "./cardmap"
import card4 from "./card4"
import card5 from "./card5"
import card6 from "./card6"
import card7 from "./card7"
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {card1,card2,card3,card4,cardMap,card5,card6,card7},
    data() {
    //这里存放数据
        return {

        };
    },
    props:{
        show:{
            type:Boolean,
            default:false
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.student_contaniner{
    width:100%;
    height:100%;
    display: flex;
}
</style>
